import { Component, Input } from '@angular/core';
import { IonicModule } from '@ionic/angular';

@Component({
    selector: 'c-label-value',
    templateUrl: './label-value.component.html',
    styleUrls: ['./label-value.component.scss'],
    imports: [IonicModule]
})
export class LabelValueComponent {
    @Input() label: string;
    @Input() value: string;
}
